import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { AppShell } from '../components/layout/AppShell';
import { ProtectedRoute } from '../components/shared/ProtectedRoute';
import { FullPageSpinner } from '../components/ui/Spinner';

// Lazy load pages
const LoginPage = lazy(() => import('../pages/LoginPage'));
const SignupPage = lazy(() => import('../pages/SignupPage'));
const HomePage = lazy(() => import('../pages/HomePage'));
const DiscoverPage = lazy(() => import('../pages/DiscoverPage'));
const CreateCapsulePage = lazy(() => import('../pages/CreateCapsulePage'));
const CapsuleDetailPage = lazy(() => import('../pages/CapsuleDetailPage'));
const ProfilePage = lazy(() => import('../pages/ProfilePage'));
const NotificationsPage = lazy(() => import('../pages/NotificationsPage'));

function SuspenseWrap({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<FullPageSpinner />}>{children}</Suspense>;
}

const router = createBrowserRouter([
  {
    path: '/login',
    element: <SuspenseWrap><LoginPage /></SuspenseWrap>,
  },
  {
    path: '/signup',
    element: <SuspenseWrap><SignupPage /></SuspenseWrap>,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <AppShell />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <SuspenseWrap><HomePage /></SuspenseWrap>,
      },
      {
        path: 'discover',
        element: <SuspenseWrap><DiscoverPage /></SuspenseWrap>,
      },
      {
        path: 'create',
        element: <SuspenseWrap><CreateCapsulePage /></SuspenseWrap>,
      },
      {
        path: 'capsule/:id',
        element: <SuspenseWrap><CapsuleDetailPage /></SuspenseWrap>,
      },
      {
        path: 'profile',
        element: <SuspenseWrap><ProfilePage /></SuspenseWrap>,
      },
      {
        path: 'notifications',
        element: <SuspenseWrap><NotificationsPage /></SuspenseWrap>,
      },
    ],
  },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
